// #region imports

// --- HS Code
import { CommandOfT } from "../shared/command";
import { GroupModel } from "./group-model";

// #endregion

export class AddGroupCommand implements CommandOfT<GroupModel[]> {
  private _isExecuted: boolean;

  private readonly _newGroup: GroupModel;
  private readonly _groups: GroupModel[];

  get groups(): GroupModel[] {
    if (!this._isExecuted) throw new Error('The command has not yet been executed. No changes have been affected!');
    return this._groups;
  }

  constructor(group: GroupModel, groups: GroupModel[]) {
    this._isExecuted = false;
    this._newGroup = group;
    this._groups = groups;
  }

  execute(): GroupModel[] {
    if (this._isExecuted) return this._groups;

    this._newGroup.isActiveGroup = true;
    this._newGroup.isNew = true;
    this._groups.forEach(g => g.isActiveGroup = false);
    this._groups.push(this._newGroup);
    this._isExecuted = true;
    return this._groups;
  }

  undo(): GroupModel[] {
    if (!this._isExecuted) return this._groups;

    const groupIndex = this._groups.findIndex(g => g.id === this._newGroup.id);
    if (groupIndex >= 0) {
      const newGroup = this._groups.splice(groupIndex, 1).at(0);
      if (newGroup?.isActiveGroup && this._groups && this._groups.length > 0) {
        this._groups.at(0)!.isActiveGroup = true;
      }
    }

    this._isExecuted = false;
    return this._groups;
  }
}
